// extracted by mini-css-extract-plugin
export default {"tooltip":"hoverText_tooltip__cPC9K","tooltipText":"hoverText_tooltipText__85HDO"};